export default [
  {
    path: '/help-center/',
    component: () => import('source/pages/root/HelpPageGroup.vue'),
    meta: {
      title: 'Help',
    },

    children: [
      {
        path: '',
        name: 'help-center',
        component: () => import('source/pages/help/HelpHomePage.vue'),
        meta: {
          title: 'Help - Browse Categories',
          canDisplayGlobalModals: true,
        },
      },
      {
        path: 'category/:category_id',
        name: 'category',
        component: () => import ('source/pages/help/HelpCategoryDetailsPage.vue'),
        props: true,
        meta: {
          title: 'Help - Browse Subcategories',
          isInternal: true
        },
      },
      {
        path: 'category/:category_id/subcategory/:subcategory_id/',
        name: 'subcategory',
        component: () => import ('source/pages/help/HelpSubcategoryPage.vue'),
        props: true,
        meta: {
          title: 'Help - Browse Topics',
          isInternal: true
        }
      },
      {
        path: 'category/:category_id/subcategory/:subcategory_id/topic/:topic_id',
        name: 'subcategory-topic',
        component: () => import('source/pages/help/TopicContentPage.vue'),
        props: true,
        meta: {
          title: 'Help - Topic',
          isInternal: true
        }
      },
      {
        path: 'category/:category_id/topic/:topic_id',
        name: 'topic',
        component: () => import ('source/pages/help/TopicContentPage.vue'),
        props: true,
          meta: {
            title: 'Help - Topic',
            isInternal: true
        }
      },
    ],
  },
];
